import {experimentalStyled as styled} from "@mui/material/styles";
import {AppBar, Toolbar} from "@mui/material";
import {Colors} from "../../ui";
import {NAVBAR_DESKTOP_HEIGHT, NAVBAR_MOBILE_HEIGHT} from "../constants";

const getLink = (pageName: string) => {
  return `https://www.bounceai.com/${pageName}`;
};

const NumberList = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
}));

const PhoneNumber = styled("a")(({theme}) => ({
  color: theme.palette.text.primary,
  textDecoration: "underline",
}));

const HeaderRoot = styled(AppBar)(() => ({
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)",
  zIndex: "100",
}));

const HeaderToolbar = styled(Toolbar)(({theme}) => ({
  boxShadow: theme.customShadows.header,
  backgroundColor: Colors.bw.white,
  minHeight: NAVBAR_MOBILE_HEIGHT,
  [theme.breakpoints.up("lg")]: {
    minHeight: NAVBAR_DESKTOP_HEIGHT,
  },
}));

const AccountRoot = styled("div")({
  display: "flex",
  overflowY: "auto",
  flexDirection: "column",
  minHeight: "100vh",
});

const AccountMain = styled("div")(({theme}) => ({
  flexGrow: 1,
  paddingTop: NAVBAR_MOBILE_HEIGHT,
  [theme.breakpoints.up("lg")]: {
    paddingTop: NAVBAR_DESKTOP_HEIGHT,
  },
}));

export {getLink, NumberList, PhoneNumber, HeaderRoot, HeaderToolbar, AccountRoot, AccountMain};
